import { useEffect, useMemo, useState } from 'react';
import { useAccountLine } from '@app/queries/account/useAccountLine';
import { IAccountLine } from '@entities/account/IAccountLine';
import { halfOfYearLabelRange } from '@app/helpers/lineChartsHelper';

function useAccountGraph(
  id?: string,
  filters?: { dateFrom: string; dateTo: string } | null
): [boolean, any] {
  const accountLineFetcher = useAccountLine();

  const [accountLine, setAccountLine] = useState<IAccountLine[] | null>(null);

  useEffect(() => {
    (async () => {
      if (!id) return;

      const items = await accountLineFetcher.fetch({
        ...filters,
        account: id,
      });
      setAccountLine(items);
    })();
  }, [filters]);

  const formatDynamicsGraphAccounts = (
    data: any,
    items: { date: string; hashrate: number; referral_hashrate: number }[]
  ) => {
    let currMonth = '';
    let isSkippedFirstIndicator = false;
    const monthForHalfOfYear = halfOfYearLabelRange(items);

    items.map(item => {
      const [, month, year] = item.date.split('-');
      let label = null;
      if (null !== monthForHalfOfYear) {
        if (currMonth !== month && monthForHalfOfYear.includes(+month)) {
          label = month + '.' + year.slice(-2);
          currMonth = month;
        }
      } else {
        if (currMonth !== month) {
          label = month + '.' + year.slice(-2);
          currMonth = month;
        }
      }

      if (!isSkippedFirstIndicator && label) {
        label = null;
        isSkippedFirstIndicator = true;
      }

      // @ts-ignore
      data[item.date] = Object.assign(data[item.date] !== undefined ? data[item.date] : {}, {
        name: label,
        Дата: item.date,
        hashRates: item.hashrate ?? 0,
        referralHashRates: item.referral_hashrate ?? 0,
      });
    });

    return data;
  };

  const graphData = useMemo(() => {
    let data: never[] = [];

    if (accountLine && accountLine.length) {
      data = formatDynamicsGraphAccounts(data, accountLine);
    }

    return Object.values(data);
  }, [accountLine]);

  const loading = !(accountLineFetcher.isSuccess && accountLine !== null);

  return [loading, graphData];
}

export default useAccountGraph;
